import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('CountriesDA', CountriesDA);

    CountriesDA.$inject = ['$q', 'CONF', 'Restangular', 'Country'];

    /**
     * Class utilitaire servant à la manipulation de dom
     */

    /* @ngInject */
    function CountriesDA($q, CONF, Restangular, Country) {
        var baseUrl = CONF.apiBaseUrl + '/v1/countries';
        var countries = null;

        var exports = {
            getAll: getAll
        };

        return exports;

        ////////////////
        function getAll() {
            // On ne récupère pas à chaque appel les pays car il ne change que très peu
            if (!countries) {
                return Restangular.oneUrl(baseUrl)
                    .getList()
                    .then(function(countryList) {
                        return _.map(countryList, function(country) {
                            return new Country(country);
                        });
                    });
            } else {
                var deferred = $q.defer();
                deferred.resolve(countries);
                return deferred.promise;
            }
        }
    }
})();
